import type { TranslationDict } from "@repo/core";

export const fr: TranslationDict = {
  // —— uiKeys ——
  "type.income": "Revenu",
  "type.expense": "Dépense",
  "type.transfer": "Virement",

  "person.household": "Foyer",
  "person.personal": "Personnel",
  "person.partner": "Partenaire",
  "person.sideHustle": "Revenus annexes",

  "method.snowball": "Boule de neige",
  "method.avalanche": "Avalanche",

  "tx.log": "Journal des transactions",
  "tx.search": "Rechercher…",
  "tx.allTypes": "Tous les types",
  "tx.allCategories": "Toutes les catégories",
  "tx.fromDate": "Date de début",
  "tx.toDate": "Date de fin",
  "tx.minAmount": "Min",
  "tx.maxAmount": "Max",
  "tx.clearFilters": "Effacer",
  "tx.entries": "{n} entrées",
  "tx.noMatch": "Aucune transaction ne correspond à vos filtres.",
  "tx.loadMore": "Charger plus ({n} restantes)",
  "tx.importCsv": "Importer CSV",
  "tx.csv": "CSV",
  "tx.add": "Ajouter",
  "tx.edit": "Modifier",
  "tx.delete": "Supprimer",
  "tx.editAria": "Modifier la transaction",
  "tx.deleteAria": "Supprimer la transaction",
  "tx.deleteConfirm": "Supprimer cette transaction ?",
  "tx.col.date": "Date",
  "tx.col.type": "Type",
  "tx.col.amount": "Montant",
  "tx.col.category": "Catégorie",
  "tx.col.account": "Compte",
  "tx.col.person": "Personne",
  "tx.col.notes": "Notes",
  "tx.account": "Compte",
  "tx.category": "Catégorie",
  "tx.chooseAccount": "— Choisir un compte —",

  "txModal.edit": "Modifier la transaction",
  "txModal.new": "Nouvelle transaction",
  "txModal.editSub": "Mettre à jour une entrée existante",
  "txModal.newSub": "Enregistrer une dépense ou un revenu",
  "txModal.type": "Type de transaction",
  "txModal.amount": "Montant",
  "txModal.date": "Date",
  "txModal.person": "Personne / Membre",
  "txModal.personPh": "Foyer, Jean, Marie…",
  "txModal.category": "Catégorie",
  "txModal.chooseCategory": "— Choisir une catégorie —",
  "txModal.notes": "Notes / Description",
  "txModal.notesPh": "Détails optionnels…",
  "txModal.recurring": "Transaction récurrente",
  "txModal.freq.weekly": "Hebdomadaire",
  "txModal.freq.monthly": "Mensuel",
  "txModal.freq.custom": "Intervalle personnalisé",
  "txModal.intervalDays": "Jours entre chaque",
  "txModal.recurringHelp":
    "Les entrées futures sont générées automatiquement. Vous pourrez ignorer une occurrence plus tard.",
  "txModal.series": "Série récurrente",
  "txModal.scopeOne": "Cette occurrence uniquement",
  "txModal.scopeSeries": "Toute la série (celle-ci et suivantes)",
  "txModal.skip": "Ignorer cette occurrence",
  "txModal.skipConfirm":
    "Ignorer uniquement cette occurrence ? Le reste de la série est conservé.",
  "txModal.saving": "Enregistrement…",
  "txModal.update": "Mettre à jour la transaction",
  "txModal.save": "Enregistrer la transaction",

  "csv.title": "Importer CSV",
  "csv.intro":
    "Associez les colonnes de votre relevé bancaire, prévisualisez les lignes, puis importez.",
  "csv.mapping": "Correspondance des colonnes",
  "csv.mappingHint":
    "À gauche : nom de colonne dans votre CSV. À droite : assignez chaque colonne à un champ BudgetOS.",
  "csv.preview": "Aperçu ({ok}/{total} valides)",
  "csv.ignore": "Ignorer",
  "csv.ok": "OK",
  "csv.importing": "Importation…",
  "csv.importN": "Importer {n} lignes",
  "csv.readError": "Impossible de lire les en-têtes CSV.",
  "csv.badDate": "Date invalide",
  "csv.badAmount": "Montant invalide",
  "csv.noCategory": "Sans catégorie",
  "csv.needAccount":
    "Ajoutez votre premier compte dans Réglages avant d'importer — les lignes CSV doivent être liées à un compte.",

  "cal.subtitle": "Suivez les dépenses quotidiennes et les séries sans dépense",
  "cal.prev": "Mois précédent",
  "cal.next": "Mois suivant",
  "cal.streak": "Série sans dépense",
  "cal.streakSub": "jours consécutifs",
  "cal.noSpendDays": "Jours sans dépense",
  "cal.thisMonth": "ce mois",
  "cal.spendDays": "Jours avec dépense",
  "cal.active": "actifs",
  "cal.totalSpent": "Total dépensé",
  "cal.avgDay": "moy. {amount}/jour",
  "cal.title": "Calendrier des dépenses (cliquez un jour pour les détails)",
  "cal.legend.noSpend": "Sans dépense",
  "cal.legend.spend": "Jour de dépense",
  "cal.legend.today": "Aujourd'hui",
  "cal.badge.noSpend": "Jour sans dépense",
  "cal.badge.spent": "Dépensé :",
  "cal.badge.income": "Revenu :",
  "cal.cleanTitle": "Belle série financière !",
  "cal.cleanBody": "Aucune dépense enregistrée ce jour. Continuez !",
  "cal.txOnDate": "Transactions à cette date ({n})",
  "cal.addForDate": "Ajouter une transaction pour cette date",

  "debt.title": "Calculateur de remboursement de dettes",
  "debt.totalDebt": "Dette totale",
  "debt.totalInterest": "Intérêts totaux",
  "debt.debtFreeDate": "Date sans dette",
  "debt.apr": "{n} % TAEG",
  "debt.currentBalance": "solde actuel",
  "debt.minPay": "Paiement min.",
  "debt.extra": "Extra",
  "debt.interest": "Intérêts",
  "debt.months": "{n} mois",
  "debt.viewSchedule": "Voir le tableau d'amortissement complet",
  "debt.hideSchedule": "Masquer le tableau d'amortissement",
  "debt.col.month": "Mois",
  "debt.col.payment": "Paiement",
  "debt.col.principal": "Capital",
  "debt.col.interest": "Intérêts",
  "debt.col.balance": "Solde",
  "debt.balance": "Solde ({symbol})",
  "debt.rate": "Taux (%)",
  "debt.minPayment": "Paiement minimum",
  "debt.extraPayment": "Paiement extra",
  "debt.chartTitle": "Solde combiné des dettes dans le temps",
  "debt.payoffOrderSnowball": "Ordre de remboursement (plus petit solde d'abord)",
  "debt.payoffOrderAvalanche": "Ordre de remboursement (taux le plus élevé d'abord)",
  "debt.exportSchedule": "Exporter le tableau",
  "debt.edit": "Modifier",

  "mb.exportMonth": "Exporter ce mois",
  "mb.income": "Revenus",
  "mb.expenses": "Dépenses",
  "mb.target": "objectif {amount}",
  "mb.budget": "budget {amount}",
  "mb.allocation": "Répartition mensuelle des dépenses",
  "mb.byGroup": "Par groupe (Besoins / Envies / Épargne)",
  "mb.topExpense": "Principales catégories de dépenses",
  "mb.incomeSources": "Sources de revenus",

  "rule.netIncome": "Revenu net mensuel",
  "rule.distribution": "Répartition 50/30/20",
  "rule.breakdown": "Détail",
  "rule.visual": "Comparaison visuelle",
  "rule.targetPct": "Objectif : {n} % du revenu",
  "rule.actual": "Réel :",
  "rule.unclassified": "{n} % du revenu non classé ou non dépensé",
  "rule.status.ahead": "En avance sur l'objectif",
  "rule.status.onTrack": "Sur la bonne voie",
  "rule.status.below": "Sous l'objectif",
  "rule.status.over": "Au-dessus du budget",
  "rule.status.under": "Sous l'objectif",

  "sf.title": "Fonds d'épargne ciblés",
  "sf.addFund": "Ajouter un fonds",
  "sf.totalSaved": "Total épargné",
  "sf.saved": "Épargné",
  "sf.target": "Objectif",
  "sf.remaining": "Restant",
  "sf.monthsLeft": "Mois restants",
  "sf.needMonth": "Besoin/mois",
  "sf.contribute": "+ Contribuer",
  "sf.contributePrompt": "Ajouter à « {name} »\nActuel : {current}\nMontant :",
  "sf.deleteConfirm": "Supprimer « {name} » ?",
  "sf.due": "Échéance {date}",
  "sf.newTitle": "Nouveau fonds d'épargne",
  "sf.name": "Nom",
  "sf.icon": "Icône",
  "sf.namePh": "ex. Vacances",
  "sf.fundIcon": "Icône du fonds",
  "sf.targetAmount": "Objectif",
  "sf.targetDate": "Date cible",
  "sf.alreadySaved": "Déjà épargné",
  "sf.color": "Couleur",
  "sf.empty": "Aucun fonds pour l'instant. Ajoutez-en un pour commencer à épargner !",

  "cf.title": "Flux de trésorerie mensuel",
  "cf.titleYear": "Flux de trésorerie mensuel · {year}",
  "cf.netSurplus": "Excédent net",
  "cf.income": "Revenus",
  "cf.expenses": "Dépenses",
  "cf.expense": "Dépense",
  "cf.netFlow": "Flux net",
  "cf.pctSaved": "{n} % épargné",
  "cf.mode.bars": "Barres groupées",
  "cf.mode.flow": "Flux lissé",
  "cf.mode.net": "Excédent net",
  "cf.avgIncome": "Revenu moyen",
  "cf.avgExpenses": "Dépenses moyennes",
  "cf.avgNet": "Excédent moyen",
  "cf.perMo": "/mois",
  "cf.peak": "Pic : {month} ({amount})",
  "cf.maxExp": "Max. dépenses : {month} ({amount})",
  "cf.png": "PNG",

  "settings.dataMgmt": "Gestion et vérification des données",
  "settings.backupTitle": "Sauvegarde et restauration",
  "settings.backupDesc":
    "Téléchargez une sauvegarde JSON de toutes les données locales, ou restaurez depuis un export précédent.",
  "settings.pdfTitle": "Rapport annuel PDF",
  "settings.pdfDesc":
    "PDF hors ligne sur mesure : couverture, KPIs, flux de trésorerie, budget, 50/30/20, dettes, fonds et patrimoine — avec graphiques intégrés.",
  "settings.currencyLocale": "Devise et région",
  "settings.theme": "Thème",
  "settings.helpSection": "Aide",
  "settings.openFaq": "Ouvrir la FAQ",
  "settings.currency": "Devise",
  "settings.preview": "Aperçu",
  "settings.negative": "Négatif :",
  "settings.compact": "Compact :",
  "settings.footer": "BudgetOS · Toutes les données sont stockées localement sur cet appareil.",
  "settings.deleteCategory":
    "Supprimer cette catégorie ? Les transactions conservent leurs montants mais perdent le lien.",
  "settings.deleteAccount": "Supprimer ce compte ?",
  "settings.noCategories": "Aucune catégorie — ajoutez-en une ci-dessus.",
  "settings.icon": "Icône",
  "settings.name": "Nom",
  "settings.monthlyTarget": "Objectif mensuel",
  "settings.group": "Groupe",
  "settings.accountNameLabel": "Nom du compte",
  "settings.openingBalance": "Solde d'ouverture",
  "settings.type": "Type",
  "settings.perMonth": "{amount}/mois",
  "settings.categoryIcon": "Icône de catégorie",
  "settings.title": "Réglages",
  "settings.subtitle": "Personnalisez l'apparence, la langue, les catégories et les données.",
  "settings.language": "Langue",
  "settings.languageSection": "Langue et région",
  "settings.datePreview": "Aperçu de la date",
  "settings.timePreview": "Aperçu de l'heure",
  "settings.currencyPreview": "Aperçu de la devise",
  "settings.relativePreview": "Temps relatif",
  "settings.categories": "Catégories",
  "settings.accounts": "Comptes",
  "settings.restoreDefaults": "Restaurer les catégories par défaut",
  "settings.restoreDefaultsConfirm":
    "Remplacer toutes les catégories par le jeu par défaut (Courses, Loyer, etc.) ? Les catégories personnalisées seront supprimées.",
  "settings.addFirstAccount":
    "Ajoutez votre premier compte pour suivre compte courant, épargne, dettes et actifs.",
  "settings.loadDemo": "Charger les données de démo",
  "settings.loadDemoDesc":
    "Efface toutes les données et remplit 12 mois de revenus, dépenses, dettes et épargne réalistes.",
  "settings.loadDemoBtn": "Charger les données de démo",
  "settings.loadingDemo": "Chargement…",
  "settings.clearAll": "Tout effacer",
  "settings.clearAllDesc":
    "Supprime définitivement transactions, comptes, dettes et fonds. Les catégories par défaut sont restaurées. Irréversible.",
  "settings.clearConfirm": "Oui, tout supprimer",
  "settings.clearing": "Effacement…",
  "settings.clearedDone":
    "Données personnelles effacées. Les catégories par défaut sont prêtes — ajoutez un compte quand vous voulez, puis enregistrez des transactions.",
  "settings.demoLoaded": "Données de démo chargées ! 12 mois de transactions sont prêts.",
  "settings.calcCheck": "Vérification des calculs",
  "settings.runVerification": "Exécuter le script de vérification",
  "settings.calcCheckDesc":
    "Confirme que le tableau de bord, le budget, le calendrier et la règle 50/30/20 restent cohérents.",
  "settings.emptyAccounts": "Ajoutez votre premier compte",
  "settings.categoryName": "Nom de la catégorie",
  "settings.accountName": "ex. Compte courant",

  "theme.curated": "Looks sélectionnés",
  "theme.fineTune": "Ajuster l'accent",
  "theme.corners": "Coins",
  "theme.accent.default": "Bleu océan",
  "theme.accent.mint": "Menthe pastel",
  "theme.accent.sand": "Sable chaud",
  "theme.accent.midnight": "Minuit",
  "theme.accent.cyberpunk": "Cyberpunk",
  "theme.radius.none": "Droit",
  "theme.radius.sm": "Léger",
  "theme.radius.md": "Par défaut",
  "theme.radius.lg": "Arrondi",
  "theme.radius.full": "Pilule",
  "theme.clean": "Clean",
  "theme.cleanBlurb": "Doux et accueillant",
  "theme.fintech": "Fintech",
  "theme.fintechBlurb": "Dense et précis",
  "theme.minimal": "Minimal",
  "theme.minimalBlurb": "Éditorial et calme",
  "theme.forest": "Forest",
  "theme.forestBlurb": "Sarcelle et crème chaude",

  "layout.brand": "BudgetOS",
  "layout.tagline": "Planificateur annuel",
  "layout.collapse": "Réduire",
  "app.loading": "Chargement de BudgetOS…",
  "app.newTx": "Ajouter une transaction",
  "app.help": "Aide",

  "print.tagline": "Budget annuel et patrimoine · Généré le {date}",
  "print.footer": "Offline-first · les données restent sur cet appareil",

  "nw.month": "Mois",
  "nw.totalAssets": "Actifs totaux ({symbol})",
  "nw.totalDebts": "Dettes totales ({symbol})",
  "nw.title": "Suivi du patrimoine net",
  "nw.logMonth": "Enregistrer le mois",
  "nw.current": "Patrimoine net actuel",
  "nw.vsLastMonth": "vs mois précédent",
  "nw.assets": "Actifs",
  "nw.debts": "Dettes",
  "nw.debtRatio": "Ratio d'endettement",
  "nw.monthsTracked": "Mois suivis",
  "nw.logForm": "Enregistrer le patrimoine net",
  "nw.trend": "Tendance du patrimoine net",
  "nw.accounts": "Répartition des comptes",
  "nw.saveLog": "Enregistrer",
  "nw.netWorth": "Patrimoine net",

  "common.noData": "Aucune donnée",
  "common.add": "Ajouter",
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",
  "common.delete": "Supprimer",
  "common.edit": "Modifier",
  "common.close": "Fermer",
  "common.export": "Exporter",
  "common.all": "Tout",
  "common.person": "Personne",
  "common.year": "Année",
  "common.loading": "Chargement…",
  "common.newTransaction": "Nouvelle transaction",
  "common.uncategorized": "Sans catégorie",
  "common.mainAccount": "Compte principal",

  "currency.USD": "Dollar américain ($)",
  "currency.EUR": "Euro (€)",
  "currency.GBP": "Livre sterling (£)",
  "currency.CAD": "Dollar canadien (CA$)",
  "currency.AUD": "Dollar australien (A$)",
  "currency.MXN": "Peso mexicain (MX$)",
  "currency.JPY": "Yen japonais (¥)",
  "currency.CHF": "Franc suisse (CHF)",
  "currency.BRL": "Real brésilien (R$)",
  "currency.INR": "Roupie indienne (₹)",

  "palette.mint": "Menthe",
  "palette.sky": "Ciel",
  "palette.coral": "Corail",
  "palette.lemon": "Citron",
  "palette.lavender": "Lavande",

  // —— non-ui (nav, groups, help, tour, dash, pdf, …) ——
  "nav.group.setup": "Configurer une fois",
  "nav.group.daily": "Usage quotidien",
  "nav.group.where": "Où vous en êtes",
  "nav.group.wealth": "Construire le patrimoine",
  "nav.dashboard": "Tableau de bord",
  "nav.monthly": "Budget mensuel",
  "nav.transactions": "Transactions",
  "nav.calendar": "Calendrier des dépenses",
  "nav.rule503020": "Règle 50/30/20",
  "nav.networth": "Patrimoine net",
  "nav.debt": "Remboursement des dettes",
  "nav.sinking": "Fonds d'épargne",
  "nav.settings": "Réglages",
  "nav.bottom.home": "Accueil",
  "nav.bottom.log": "Journal",
  "nav.bottom.budget": "Budget",
  "nav.bottom.debt": "Dettes",
  "nav.bottom.wealth": "Patrimoine",

  "group.income": "Revenus",
  "group.needs": "Besoins",
  "group.wants": "Envies",
  "group.savings": "Épargne",

  "accountType.checking": "Courant",
  "accountType.savings": "Épargne",
  "accountType.asset": "Actif",
  "accountType.debt": "Dette",

  "cat.cat-sal": "Salaire",
  "cat.cat-side": "Revenus annexes",
  "cat.cat-div": "Dividendes",
  "cat.cat-rent": "Loyer / Crédit immobilier",
  "cat.cat-util": "Charges",
  "cat.cat-groc": "Courses",
  "cat.cat-ins": "Assurances",
  "cat.cat-trans": "Transport",
  "cat.cat-health": "Santé",
  "cat.cat-eat": "Restaurants",
  "cat.cat-ent": "Divertissement",
  "cat.cat-shop": "Achats",
  "cat.cat-sub": "Abonnements",
  "cat.cat-travel": "Voyages",
  "cat.cat-emerg": "Fonds d'urgence",
  "cat.cat-invest": "Investissements",
  "cat.cat-ret": "Retraite (401k)",

  "demo.acc-check": "Compte courant Chase",
  "demo.acc-sav": "Épargne HYSA",
  "demo.acc-cc1": "Carte Visa",
  "demo.acc-car": "Crédit auto",
  "demo.acc-inv": "Compte-titres",
  "demo.acc-401k": "401(k)",
  "demo.dbt-cc": "Carte Visa",
  "demo.dbt-car": "Crédit auto",
  "demo.dbt-sl": "Prêt étudiant",
  "demo.sf-hol": "Voyage de vacances",
  "demo.sf-emg": "Fonds d'urgence",
  "demo.sf-car": "Apport voiture neuve",
  "demo.sf-home": "Réparations maison",
  "demo.sf-tech": "Nouveau portable",
  "demo.note.overDining": "Dîner entre amis",
  "demo.note.workLunch": "Déjeuner de travail",
  "demo.note.weekendOut": "Sortie du week-end",

  "qs.unzip.title": "Avant de commencer : decompressez le dossier",
  "qs.unzip.windows":
    "Windows : clic droit sur le fichier .zip -> « Extraire tout » -> choisissez ou l'enregistrer.",
  "qs.unzip.mac":
    "Mac : double-cliquez sur le fichier .zip - il se decompresse automatiquement a cote du zip d'origine.",
  "qs.unzip.open":
    "Ouvrez le dossier cree (meme nom que le zip). Vous y trouverez index.html, ce guide, et un dossier nomme assets.",
  "qs.unzip.warn":
    "Ne deplacez pas et ne renommez pas index.html separement, et ne le sortez pas de ce dossier - il doit rester a cote du dossier assets pour fonctionner.",

  "demo.banner":
    "Ceci est une démo en direct de BudgetOS — données d'exemple, réinitialisées à chaque visite.",
  "demo.readOnly":
    "Ceci est une démo d'aperçu. Les modifications ne sont pas enregistrées — obtenez la version complète sur Etsy pour votre propre budget.",
  "demo.cta": "Obtenir la version complète",
  "demo.ctaHint": "Définissez VITE_ETSY_URL pour lier ce bouton à votre annonce Etsy.",

  "help.title": "Aide et FAQ",
  "help.close": "Fermer l'aide",
  "help.replayTour": "Rejouer le tour de démarrage",
  "help.quickStart": "Ouvrir le guide de démarrage (PDF)",
  "help.quickStartHtml": "Ouvrir la version HTML",
  "help.q0": "Comment fonctionnent la sauvegarde et la restauration ?",
  "help.a0":
    "Réglages → Sauvegarde et restauration télécharge un fichier JSON avec toutes les catégories, transactions, dettes et fonds. Importez ce fichier sur le même navigateur ou un autre pour restaurer exactement. Sauvegardez régulièrement — ce fichier est votre seule copie portable.",
  "help.q1": "Comment transférer les données vers un nouvel appareil ou navigateur ?",
  "help.a1":
    "Exportez une sauvegarde sur l'ancien appareil, ouvrez BudgetOS sur le nouveau, puis Importer la sauvegarde. Faites-le avant d'effacer les données du site ou de changer de navigateur.",
  "help.q2": "Comment tout réinitialiser ?",
  "help.a2":
    "Réglages → Tout effacer supprime définitivement transactions, comptes, dettes et fonds, puis restaure les catégories par défaut. Les comptes ne sont pas recréés (ajoutez les vôtres). Un rafraîchissement ne ramène pas la démo sauf si vous cliquez Charger les données de démo. Pour les catégories seules : Restaurer les catégories par défaut.",
  "help.q3": "Comment changer la devise ou la langue ?",
  "help.a3":
    "Réglages → Devise pour le format monétaire. Réglages → Langue et région pour la langue de l'app. Les montants enregistrés restent inchangés.",
  "help.q4": "Tout fonctionne-t-il hors ligne ?",
  "help.a4":
    "Oui. Une fois l'app chargée, BudgetOS n'a pas besoin d'internet. Graphiques, dettes, exports et sauvegardes tournent en local.",
  "help.q5": "Quels navigateurs sont pris en charge ?",
  "help.a5":
    "Chrome, Firefox, Edge et Safari actuels. Utilisez un navigateur moderne avec IndexedDB. Le mode privé peut effacer les données à la fermeture.",
  "help.q6": "Important : ne déplacez pas le fichier HTML après avoir enregistré des données",
  "help.a6":
    "Si vous ouvrez BudgetOS via file:// (courant avec les téléchargements Etsy), certains navigateurs — surtout Safari — lient le stockage à ce chemin. Exportez une sauvegarde avant de renommer ou déplacer le fichier, puis réimportez après.",
  "help.q7": "Le PDF affiche une URL ou une date en marge — est-ce un bug ?",
  "help.a7":
    "Le rapport annuel et les PDF de section sont générés hors ligne avec jsPDF (pas le dialogue Imprimer du navigateur), avec en-têtes BudgetOS, numéros de page et graphiques. Si vous utilisez Imprimer du navigateur, vous pouvez désactiver en-têtes/pieds dans le dialogue.",

  "tour.skip": "Passer",
  "tour.back": "Retour",
  "tour.next": "Suivant",
  "tour.done": "Commencer",
  "tour.step": "Étape {n} sur {total}",
  "tour.choice.eyebrow": "Bienvenue",
  "tour.choice.title": "Comment voulez-vous commencer ?",
  "tour.choice.body":
    "Choisissez une fois. Vous pourrez charger ou effacer la démo plus tard dans Réglages.",
  "tour.choice.sample": "Explorer avec des données d’exemple",
  "tour.choice.sampleDesc": "Charge une année réaliste de démo pour parcourir l’app.",
  "tour.choice.empty": "Commencer avec mes données",
  "tour.choice.emptyDesc": "App vide — catégories par défaut seulement. Ajoutez votre première transaction quand vous voulez.",
  "tour.s0.title": "Vos données restent sur cet appareil",
  "tour.s0.body":
    "BudgetOS est offline-first. Tout est stocké dans ce navigateur — pas de compte, pas de cloud, pas de tracking.",
  "tour.s1.title": "Ajoutez une transaction à tout moment",
  "tour.s1.body":
    "Appuyez sur + (ou Transactions → Ajouter) pour enregistrer un revenu ou une dépense. Les totaux se mettent à jour instantanément.",
  "tour.s2.title": "Réglages et sauvegardes",
  "tour.s2.body":
    "Ouvrez Réglages pour changer devise, thème, catégories, et télécharger une sauvegarde JSON. Exportez avant de changer de navigateur.",
  "tour.s3.title": "Essayez la démo quand vous voulez",
  "tour.s3.body":
    "Réglages → Charger les données de démo remplit une année réaliste. Tout effacer la retire quand vous êtes prêt pour vos chiffres.",
  "tour.s4.title": "L'aide est toujours là",
  "tour.s4.body": "Rouvrez ce tour ou la FAQ via le bouton ?. Vous êtes prêt à budgéter.",

  "empty.accounts.networth": "Ajoutez votre premier compte dans Réglages pour voir les soldes ici.",
  "empty.debts":
    "Aucune dette pour l'instant. Chargez la démo ou ajoutez des dettes en configurant vos comptes — cet écran reste prêt.",
  "empty.tx.noAccount":
    "Aucun compte encore — vous pouvez quand même enregistrer. Ajoutez votre premier compte dans Réglages quand vous voulez.",

  "dash.yearGlance": "L'année en un coup d'œil — {year}",
  "dash.downloadReport": "Télécharger le rapport annuel",
  "dash.buildingPdf": "Génération du PDF…",
  "dash.savingsGoal": "Progression de l'objectif d'épargne",
  "dash.savingsRateTarget": "Taux d'épargne · Objectif 20 %",
  "dash.rateVsTarget": "Taux vs objectif 20 %",
  "dash.monthHighlights": "Points forts du mois",
  "dash.kpi.moneyIn": "Argent entrant",
  "dash.kpi.moneyOut": "Argent sortant",
  "dash.kpi.leftover": "Reste",
  "dash.kpi.savingsRate": "Taux d'épargne",
  "dash.kpi.totalSaved": "Total épargné",

  "pdf.tagline": "Planificateur annuel hors ligne",
  "pdf.cover.disclaimer":
    "Les chiffres correspondent aux calculs BudgetOS à l'écran. Généré entièrement hors ligne.",
  "pdf.generated": "Généré le {date}",
  "pdf.page": "Page {n} sur {total}",
  "pdf.view": "Vue : {person}",
  "pdf.title.annual": "Rapport annuel {year}",
  "pdf.period.detail": "Rapport annuel {year} · détail {month}",
  "pdf.section.yearGlance": "L'année en un coup d'œil",
  "pdf.section.cashFlow": "Flux de trésorerie mensuel",
  "pdf.section.budget": "Budget mensuel — {month} {year}",
  "pdf.section.rule": "Répartition 50/30/20",
  "pdf.section.debts": "Résumé des dettes",
  "pdf.section.funds": "Fonds d'épargne",
  "pdf.section.netWorth": "Patrimoine net",
  "pdf.col.kpi": "KPI",
  "pdf.col.value": "Valeur",
  "pdf.col.month": "Mois",
  "pdf.col.in": "Entrées",
  "pdf.col.out": "Sorties",
  "pdf.col.leftover": "Reste",
  "pdf.col.category": "Catégorie",
  "pdf.col.target": "Objectif",
  "pdf.col.actual": "Réel",
  "pdf.col.variance": "Écart",
  "pdf.col.group": "Groupe",
  "pdf.col.bucket": "Poste",
  "pdf.col.amount": "Montant",
  "pdf.col.pctIncome": "% du revenu",
  "pdf.col.targetPct": "% objectif",
  "pdf.col.debt": "Dette",
  "pdf.col.balance": "Solde",
  "pdf.col.apr": "TAEG",
  "pdf.col.interest": "Intérêts",
  "pdf.col.months": "Mois",
  "pdf.col.payoff": "Remboursement",
  "pdf.col.fund": "Fonds",
  "pdf.col.saved": "Épargné",
  "pdf.col.progress": "Progression",
  "pdf.col.moNeeded": "Besoin/mois",
  "pdf.col.assets": "Actifs",
  "pdf.col.debts": "Dettes",
  "pdf.col.net": "Net",
  "pdf.col.account": "Compte",
  "pdf.col.type": "Type",
  "pdf.col.payment": "Paiement",
  "pdf.col.principal": "Capital",
  "pdf.sub.incomeSources": "Sources de revenus",
  "pdf.sub.nws": "Besoins / Envies / Épargne",
  "pdf.sub.expenseCats": "Catégories de dépenses",
  "pdf.sub.accounts": "Répartition des comptes",
  "pdf.kpi.moneyIn": "Argent entrant",
  "pdf.kpi.moneyOut": "Argent sortant",
  "pdf.kpi.leftover": "Reste",
  "pdf.kpi.savingsRate": "Taux d'épargne",
  "pdf.kpi.totalSaved": "Total épargné",
  "pdf.savingsGoal": "Objectif d'épargne : {actual} / {target}",
  "pdf.debtSummary":
    "Dette totale {debt} · Intérêts totaux {interest} · Sans dette {date}",
  "pdf.nwSummary": "Net {net} · Actifs {assets} · Dettes {debts}",
  "pdf.empty.debts": "Aucune dette enregistrée.",
  "pdf.empty.funds": "Aucun fonds d'épargne enregistré.",
  "pdf.empty.chart": "Aucun graphique disponible pour cette période.",
  "pdf.empty.rule":
    "Aucune répartition des dépenses sur cette période — les réels sont à 0.",
  "pdf.chart.cashFlow": "Flux de trésorerie mensuel",
  "pdf.chart.income": "Revenus",
  "pdf.chart.expense": "Dépenses",
  "pdf.chart.rule": "50/30/20 · {month} {year}",
  "pdf.chart.netWorthTrend": "Tendance du patrimoine net",
  "pdf.chart.netWorth": "Patrimoine net",
  "pdf.chart.assets": "Actifs",
  "pdf.chart.debts": "Dettes",
  "pdf.chart.emptySpend": "Aucune dépense sur cette période",
  "pdf.chart.emptyHint":
    "Besoins / Envies / Épargne apparaîtront lorsque ce mois aura des dépenses.",
  "pdf.amortization": "Amortissement — {name}",
  "pdf.payoffInterest": "Remboursement {date} · Intérêts {interest}",
};
